import {initNavigation} from './soltis-jungle-navigation.js?v=no-serving-20261025';
import {initContactPopup} from './soltis-jungle-contact-popup.js?v=popup-once-per-visit-v3-20261025';

document.documentElement.classList.remove('no-js');
document.querySelectorAll('a[href]').forEach(link => {
  const url = new URL(link.href, location.href);
  if (url.origin === location.origin && /^\/pages\/(contact-us|get-started|free-seo-audit)\/?$/.test(url.pathname)) {
    link.dataset.contactOpen = '';
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', 'contact-popup');
  }
});
initNavigation(document.querySelector('.site-nav'));
initContactPopup(document.querySelector('.contact-dialog'));

const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
const progress = document.querySelector('.reading-progress');
if (progress) {
  let frame;
  const update = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    progress.style.transform = `scaleX(${max > 0 ? Math.min(1, scrollY / max) : 0})`;
    frame = undefined;
  };
  addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive:true});
  addEventListener('resize', update, {passive:true});
  update();
}

// A small pointer response is confined to decoration; copy and controls never move.
const stage = document.querySelector('.nx-hero-art');
if (stage && !reducedMotion.matches && matchMedia('(pointer:fine)').matches) {
  let frame;
  stage.addEventListener('pointermove', event => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      const box = stage.getBoundingClientRect();
      stage.style.setProperty('--nx-pointer-x', `${((event.clientX - box.left) / box.width - .5) * 18}px`);
      stage.style.setProperty('--nx-pointer-y', `${((event.clientY - box.top) / box.height - .5) * 12}px`);
      frame = undefined;
    });
  }, {passive:true});
  stage.addEventListener('pointerleave', () => {
    stage.style.setProperty('--nx-pointer-x', '0px');
    stage.style.setProperty('--nx-pointer-y', '0px');
  });
}
